// Unterlagen für mehrere Standorte auf einmal: ZIP oder Ordner mit einem Unterordner je Standort.
import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { DbPortalUploadErgebnis } from '@gql/shared-types';
import { UploadBereich } from '../components/UploadBereich.js';

export function Lieferung() {
  const [ergebnis, setErgebnis] = useState<DbPortalUploadErgebnis | null>(null);
  return (
    <div className="seite">
      <p className="brotkrumen">
        <Link to="/standorte">← Zu den Standorten</Link>
      </p>
      <h1>Unterlagen für mehrere Standorte hochladen</h1>
      <p>
        Für einzelne Standorte laden Sie Unterlagen am einfachsten auf der Seite des Standorts hoch. Hier können Sie viele
        Standorte auf einmal beliefern:
      </p>
      <ol className="schritte">
        <li>
          Legen Sie je Standort einen Ordner an und benennen Sie ihn mit der <strong>Externen ID</strong> (z. B.{' '}
          <code>T-001</code>) oder dem <strong>Standortnamen</strong> aus Ihrer Standortliste.
        </li>
        <li>
          Legen Sie alle Unterlagen des Standorts hinein (Verträge, AGB, Rechnungen, Entgeltänderungen …). Unterordner mit
          Jahreszahl (z. B. <code>2015</code>) oder Dateinamen mit „Rechnung“ bzw. „Vertrag“ helfen bei der Zuordnung, sind
          aber nicht nötig – die Unterlagen werden automatisch sortiert und ausgewertet.
        </li>
        <li>Ziehen Sie die Ordner hierher oder packen Sie sie in eine ZIP-Datei.</li>
      </ol>
      <UploadBereich standortId={null} onHochgeladen={setErgebnis} />
      {ergebnis && ergebnis.lieferungen.length > 0 && (
        <section aria-labelledby="h-ergebnis">
          <h2 id="h-ergebnis">Zugeordnet</h2>
          <ul>
            {ergebnis.lieferungen.map((l) => (
              <li key={l.id}>
                <Link to={`/standorte/${l.standortId}`}>Zum Standort</Link> – {l.dokumente} {l.dokumente === 1 ? 'Dokument' : 'Dokumente'}
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
